module.exports = __webpack_public_path__ + "img/qrcode.05d4c7dd.png";